// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchInput_root__kHkoc","input":"SearchInput_input__2BAr7","close":"SearchInput_close__2s_Ql"};